<template>
  <div>
    <!-- <p class="font-weight-bold">
      <ConsoleLink to="/formula-variable" class="text-primary">
        {{ $t('sideBar.formula_variable') }} >
      </ConsoleLink> {{ $t('utils.add') }} {{ $t('sideBar.formula_variable') }}
    </p> -->

    <a-breadcrumb separator=">">
      <a-breadcrumb-item>
        <ConsoleLink to="/formula-variable" class="text-primary">
          {{ $t('sideBar.formula_variable') }}
        </ConsoleLink>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        {{ $t('utils.add') }} {{ $t('sideBar.formula_variable') }}
      </a-breadcrumb-item>
    </a-breadcrumb>

    <AddFormulaVariable :permission="permission" />
  </div>
</template>

<script>
import AddFormulaVariable from '@/components/Price/Formula-Variable/Add'
import ConsoleLink from '@/components/ConsoleLink/ConsoleLink.vue'

export default {
  components: {
    AddFormulaVariable,
    ConsoleLink,
  },
  computed: {
    permission() {
      return this.$store.getters['user/can']('formula-variable')
    },
  },
  // watch: {
  //   permission(newValue) {
  //     if(!newValue.length || !newValue.includes('WRITE')) {
  //       this.$router.push({path: '/error/403', query: {...this.$route.query}})
  //     }
  //   },
  // },
}
</script>
